import React from 'react';

import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { Form, FormGroup, Label, Input, Row, Col, Button } from 'reactstrap';

//Scripts auxiliares:
import {forceUserLogout} from '../../../tools/scripts/userRelated';
import {registerAuditProcess} from '../../../tools/scripts/customFetching';

//Estilos base:
let errorLabelStyles = { color: "red", marginLeft: 10, marginBottom: 5, marginTop: 5 };

class UserCreationForm extends React.Component {

    constructor() {
        super();

        this.state = {
            existingUserLabelIsActive: false,
            wrongPasswordsLabelIsActive: false
        }
    }

    render() {
        return (
            <Form style={{ marginTop: 25, marginBottom: 0 }}
                onSubmit={(e) => {
                    e.preventDefault();

                    if (e.target.password.value === e.target.verifiedPassword.value) {
                        this.createUserFromBackend(e);
                    }
                    else {
                        this.setState({ wrongPasswordsLabelIsActive: true });
                    }
                }}>
                <FormGroup>
                    <Row>
                        <Col md="5">
                            <Label for="newUserEmailInput" style={{ marginTop: 10 }}>Correo electrónico</Label>
                        </Col>

                        <Col md="7">
                            <Input type="email" name="email" id="newUserEmailInput" placeholder="correo electrónico" required/>
                        </Col>
                    </Row>

                    {this.getExistingUserLabel()}
                </FormGroup>

                <FormGroup>
                    <Row>
                        <Col md="5">
                            <Label style={{ marginTop: 10 }}>Contraseña</Label>
                        </Col>

                        <Col md="7">
                            <Input type="password" name="password" placeholder="contraseña" required/>
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup>
                    <Row>
                        <Col md="5">
                            <Label style={{ marginTop: 10 }}>Contraseña (de nuevo)</Label>
                        </Col>

                        <Col md="7">
                            <Input type="password" name="verifiedPassword" placeholder="repite la contraseña" required/>
                        </Col>
                    </Row>
                </FormGroup>

                {this.getWrongPasswordsLabel()}
                <Button className="not-visible-button" id="newUserSubmitButton" />
            </Form>
        );
    }

    //Métodos operativos:
    createUserFromBackend = (e) => {
        this.setState({ wrongPasswordsLabelIsActive: false, existingUserLabelIsActive: false });
        
        let targetEmail = e.target.email.value;
        let targetPassword = e.target.password.value;

        fetch(process.env.REACT_APP_API_URL + "/users/createUser/", {
            method: 'post',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken, 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'email': targetEmail, 'password': targetPassword, "country_scope": this.props.activeUser.country_scope })
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                    case 201:
                        serverResponse.json()
                            .then(processResult => {
                                if (processResult.response !== undefined) {
                                    if (processResult.response.toLowerCase() === "success"){
                                        this.fireSuccessProcessAlert();

                                        registerAuditProcess(this.props, {
                                            "event_type": "USER_CREATED",
                                            "description": "El usuario <b>registró a " + targetEmail + "</b> en la plataforma"
                                        });
                                    }
                                    else
                                        this.fireFailedProcessAlert();
                                }
                                else {
                                    if (JSON.stringify(processResult).includes("this email already exists."))
                                        this.setState({ existingUserLabelIsActive: true });
                                    else
                                        this.fireFailedProcessAlert();
                                }
                            })
                        break;

                    case 401:
                        forceUserLogout();
                        break;

                    default:
                        this.fireFailedProcessAlert();
                }
            })
            .catch(error => { console.log(error); this.fireFailedProcessAlert(); })
    }

    //Métodos para renderizado:
    getExistingUserLabel = () => {
        if (this.state.existingUserLabelIsActive) {
            return (
                <p style={{ ...errorLabelStyles }}>
                    Este correo electrónico ya está ocupado...
                </p>
            );
        }
    }

    getWrongPasswordsLabel = () => {
        if (this.state.wrongPasswordsLabelIsActive) {
            return (
                <p style={{ ...errorLabelStyles }}>
                    Las contraseñas no coinciden...
                </p>
            );
        }
    }

    //Métodos relacionados con sweet alert:
    fireFailedProcessAlert = () => {
        Swal.fire('', 'El registro del usuario no pudo completarse correctamente', 'error');
    }

    fireSuccessProcessAlert = () => {
        Swal.fire('', 'El usuario fue <b>registrado con éxito</b>', 'success');

        if(this.props.reloadUsersFunction) this.props.reloadUsersFunction();
        if(this.props.modalToggle) this.props.modalToggle();     
    }

}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost,
        enableAuditRegistering: state.mainReducer.enableAuditRegistering
    };
};

export default connect(mapStateToProps)(UserCreationForm);